// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row } from 'react-bootstrap'
import { ActivityTable } from '../components/activityTable'
import { Message } from '../components/message'
import config from '../config/config.json'

export class PerformanceDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            officialResults: []
        }

        this.getOfficialResults(this.props.activeWorkerId, this.props.env, config)
        this.getOfficialResults = this.getOfficialResults.bind(this)
        this.displayResults = this.displayResults.bind(this)
        this.prepareBreadcrumb = this.prepareBreadcrumb.bind(this)
    }


    getOfficialResults(workerId, env, config) {
        fetch(config[env] + config.api.list_official_games.endpoint + workerId, {
            method: config.api.list_official_games.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                let activeResults = responseJson.filter(result => {
                    return result.enabler_module === this.props.activeModuleName
                })
                this.setState({
                    officialResults: activeResults
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    displayResults() {
        if (this.state.officialResults.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="No results data found for this module."
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <section className="results">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <section className="official-results results">
                                <ActivityTable
                                    results={this.state.officialResults}
                                    title="Official Results"
                                />
                            </section>
                        </Col>
                    </Row>
                </section>
            )
        }
    }

    prepareBreadcrumb() {
        return (<div className="breadcrumb"><span><Link to="/performance">Performance Breakdown</Link></span>/<span><Link to="/performance/summary/content">{this.props.activeWorkerName + "'s Content"}</Link></span>/</div>)
    }

    render() {
        return (
            <section className="worker-performance">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            {this.prepareBreadcrumb()}

                            <h2 className="title">{this.props.activeWorkerName + "'s Performance"}</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <section className="module-info">
                            <h3 className="module-title">Module: {this.props.activeModuleName}</h3>
                        </section>
                    </Col>
                </Row>
                {this.displayResults()}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/performanceDetails.js